import * as React from 'react';
import { Select } from 'antd';
import { observer } from 'mobx-react-lite';
import { TestProjectWizardStore } from '../stores';

const { Option } = Select;

type Props = {
    store: TestProjectWizardStore;
};

export const TestProjectTagsEditor: React.FC<Props> = ({ store }) => {
    return (
        <>
            <Select
                data-id="test-project-tags-editor-modal-select"
                style={{ width: '100%' }}
                mode="tags"
                value={store.testProjectUserTags}
                onChange={(v: string[]) => store.setTestProjectUserTags(v)}
                placeholder="Select or type tags..."
            >
                {store.availableTestProjectUserTags.map((k, i) => (
                    <Option data-id={`test-project-tags-editor-modal-select-${k}`} key={`tag-${i}`} value={k}>
                        {k}
                    </Option>
                ))}
            </Select>
        </>
    );
};

export default observer(TestProjectTagsEditor);
